import { Theme } from '@glideapps/glide-data-grid';

import { fontFamily } from '@/theme';

import { useAntDesignTheme } from './useAntDesignTheme';

export const useGlideDataGridTheme = () => {
    const { token } = useAntDesignTheme();

    const tableTheme: Partial<Theme> = {
        accentColor: token.blue4,
        accentFg: token.colorBgContainer,
        accentLight: token.blue1,

        textDark: token.colorText,
        textMedium: token.colorTextSecondary,
        textLight: token.colorTextLightSolid,
        textBubble: token.colorBgContainer,

        bgIconHeader: token.colorTextSecondary,
        fgIconHeader: token.colorTextSecondary,
        textHeader: token.colorTextSecondary,
        textHeaderSelected: token.colorTextLightSolid,
        textGroupHeader: token.colorTextSecondary,

        bgCell: token.colorBgContainer,
        bgCellMedium: token.colorBgBase,
        bgHeader: token.colorBgBase,
        bgHeaderHasFocus: token.colorBorder,
        bgHeaderHovered: token.colorBorder,

        bgBubble: token.colorBgBase,
        bgBubbleSelected: token.colorBgContainer,

        bgSearchResult: token.colorFillAlter,

        borderColor: token.colorBorder,
        drilldownBorder: token.colorBorder,

        linkColor: token.blue6,

        headerIconSize: 16,

        headerFontStyle: 'normal 0.75rem',
        baseFontStyle: '400 0.825rem',
        markerFontStyle: '6px',
        fontFamily: fontFamily,
    };

    const relationsTableTheme: Partial<Theme> = {
        accentColor: token.blue4,
        accentFg: token.colorBgContainer,
        accentLight: token.blue1,

        textDark: token.colorText,
        textMedium: token.colorTextSecondary,
        textLight: token.colorTextLightSolid,
        textBubble: token.colorText,

        bgIconHeader: token.colorTextSecondary,
        fgIconHeader: token.colorTextSecondary,
        textHeader: token.colorTextSecondary,
        textHeaderSelected: token.colorTextLightSolid,
        textGroupHeader: token.colorTextSecondary,

        bgCell: token.colorBgContainer,
        bgCellMedium: token.colorBgContainer,
        bgHeader: token.colorBgContainer,
        bgHeaderHasFocus: token.colorBorder,
        bgHeaderHovered: token.colorBorder,

        bgBubble: token.colorBgBase,
        bgBubbleSelected: token.colorBgContainer,

        bgSearchResult: token.gold1,

        borderColor: token.colorBorder,
        drilldownBorder: token.colorBorder,
        horizontalBorderColor: token.colorBorder,
        headerBottomBorderColor: token.colorBorder,

        linkColor: token.blue6,

        headerIconSize: 16,

        headerFontStyle: 'normal 0.75rem',
        baseFontStyle: '400 0.825rem',
        markerFontStyle: '6px',
        fontFamily: fontFamily,
        roundingRadius: token.borderRadius,
        lineHeight: token.lineHeight,
        resizeIndicatorColor: token.blue6,
    };

    return { tableTheme, relationsTableTheme };
};
